import { api } from '../../api';
import { ComplianceAutotrackingRequest } from '../../model/compliance/ComplianceAutotrackingRequest';
import { CompliancePeriod } from '../../model/compliance/CompliancePeriod';

export const complianceService = {
  getOverview,
  getPeriods,
  updatePeriod,
  toggleAutoTracking,
};

function getOverview(patientGuid: string) {
  return api.get(`/patientcompliance/current/${patientGuid}`);
}

function getPeriods(patientGuid: string) {
  return api.get(`/patientcompliance/${patientGuid}`);
}

function updatePeriod(period: CompliancePeriod) {
  return api.put('/patientcompliance', period);
}

function toggleAutoTracking(request: ComplianceAutotrackingRequest) {
  return api.put('/patientcompliance/switch-calculation', request);
}
